/** @format */

import { useEffect } from "react";
import { Container } from "../../components/layouts/Container";
import useGTMHooks from "../../hooks/useGTMHooks";
import OcnkTeikiEconomicEstimateElement from "../../components/ui_elements/ocnkTeiki/Economic/EconomicEstimateElement";

const OcnkTeikiRedirectEconomic = ({ redirect }: { redirect?: boolean }) => {
  const { pushDataLayerHandler } = useGTMHooks();
  useEffect(() => {
    pushDataLayerHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container isLogin={true} background={"default"} align={"top"} redirect={redirect}>
      <OcnkTeikiEconomicEstimateElement redirect={redirect} />
    </Container>
  );
};

export default OcnkTeikiRedirectEconomic;
